// libs
import { useDispatch } from 'react-redux';

//actions
import { setSelectedSKUID } from 'shared/store/details/actions';

export const useSetSelectedSKU = () => {
  const dispatch = useDispatch();

  return (payload: { skuId: string; oneSize: boolean }) => dispatch(setSelectedSKUID(payload));
};
